/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/prefer-default-export
export class BaseAutocompleteAdapter {
    constructor() {
        this.autocomplete = null;
    }

    /**
     * Get events.
     * @param {object} getEventsDto The event dto.
     * @returns void
     */
    getResults(query) {
        throw new Error(`Method not implemented`);
    }
}
